import { httpClient } from 'api';
import { Pair } from '../types/Pair';

export type Step = {
	no: number;
	type: string;
	data?: Record<string, string | number>;
};

export type StepPair = Step & {
	condition: boolean;
};

type PairSelected = Pick<
	Pair,
	'id' | 'status' | 'menteeMembership' | 'mentorMembership' | 'acceptedByMentor' | 'acceptedByMentee' | 'entryMeeting'
>;

export type StepsCommonData = {
	activeStep: number;
	steps: Step[];
};

export type StepsPairData = {
	pairId: number;
	pair: PairSelected;
	activeStep: number;
	steps: StepPair[] | null;
	secondStage: boolean;
};

export type StepsResponse = StepsCommonData | StepsPairData[];

export const stepsApi = {
	getSteps: ({ pairId, applicationId }: { applicationId: number; pairId?: number }) =>
		httpClient.get<StepsResponse>(`steps/${applicationId}`, { pairId }),
};
